import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';

function ActionButtons({title, status, page}) {
  const navigate= useNavigate()

  return (

    <Stack direction='row' spacing={1}>
    <Tooltip title="Edit">
      <IconButton sx={{ color: '#0066b2', '&:hover': {backgroundColor: '#88a3c9', color: 'white' }}} size='small' >
        <ModeEditOutlineOutlinedIcon />
      </IconButton>
    </Tooltip>

    <Tooltip title="Delete">
      <IconButton sx={{ color: '#CD5C5C', '&:hover': {backgroundColor: '#df9797', color: 'white' } }} >
        <DeleteOutlineOutlinedIcon />
      </IconButton>

    </Tooltip>
    {status &&
     <Tooltip title={title}>
     <IconButton sx={{ color: '#489C8F', '&:hover': {backgroundColor: '#489C8F', color: 'white' } }}  onClick={()=>navigate(`/${page}`)}>
       <KeyboardDoubleArrowRightOutlinedIcon />
     </IconButton>
   </Tooltip>
    }

  </Stack>
  )
}

export default ActionButtons